import { useEffect, useState } from 'react'

let backgroundMusic: HTMLAudioElement | null = null
let correctSound: HTMLAudioElement | null = null
let wrongSound: HTMLAudioElement | null = null

export function useAudio() {
	const [isMusicPlaying, setIsMusicPlaying] = useState(true)

	useEffect(() => {
		if (!backgroundMusic) {
			backgroundMusic = new Audio('./assets/audio/musica_fundo.mp3')
			backgroundMusic.loop = true
			backgroundMusic.volume = 0.3
		}

		if (!correctSound) {
			correctSound = new Audio('./assets/audio/correct.mp3')
			correctSound.volume = 0.5
		}

		if (!wrongSound) {
			wrongSound = new Audio('./assets/audio/wrong.mp3')
			wrongSound.volume = 0.5
		}
	}, [])

	const startMusic = () => {
		if (backgroundMusic && !isMusicPlaying) {
			backgroundMusic.play().catch((err) => {
				console.error('Background music:', err)
			})
			setIsMusicPlaying(true)
		}
	}

	const stopMusic = () => {
		if (backgroundMusic && isMusicPlaying) {
			backgroundMusic.pause()
			setIsMusicPlaying(false)
		}
	}

	const playCorrect = () => {
		if (correctSound) {
			correctSound.currentTime = 0
			correctSound.play().catch(() => {})
		}
	}

	const playWrong = () => {
		if (wrongSound) {
			wrongSound.currentTime = 0
			wrongSound.play().catch(() => {})
		}
	}

	const toggleBackgroundMusic = () => {
		if (isMusicPlaying) {
			stopMusic()
		} else {
			startMusic()
		}
	}

	return { playCorrect, playWrong, toggleBackgroundMusic, isMusicPlaying, startMusic, stopMusic }
}
